<div class="main-page">
    <!-- <nav class="navbar navbar-expand-lg navbar-light bg-light header">
		<div class="logo"><a (click)="redirect()"><img src="assets/logo-4.png"></a></div>
	</nav> -->
    <app-header></app-header>
    <app-side-bar></app-side-bar>
    <div class="container">
        <div class="setting-text-area">
            <div class="innerPage setting-text-area-inner">
                <div class="pg-header">
                  <button type="button" class="pg-back" (click)="backDashboard()" aria-label="Back">
                    <i class="fa fa-arrow-left"></i>
                  </button>
                  <div class="pg-heading">
                    <div class="pg-title">Photo Gallery</div>
                    <div class="pg-subtitle">Add up to {{ photoLimit }} photos (max 2MB each)</div>
                  </div>
                </div>
                <div class="row">
                    <div class="col-12">

                        <div *ngIf=" photoarr.length < this.photoLimit" class="pg-info">
                            Add {{ photoLimit }} photos to your gallery (Max 2 Mb)
                        </div>

                        <div *ngIf=" photoarr.length == this.photoLimit" class="pg-info pg-info--success">
                            Business photos added to your gallery.

                        </div>
                        <div>
                          <div class="pg-grid">

                              <div class="form-group register-input" *ngFor="let props of photoarr; let i = index">

                                  <div class="position-relative" >

                                      <div *ngIf="photoarr[i].deleteImage" class="spinner-border text-muted"
                                          style="position: absolute; top:40%; left:40%;"></div>

                                      <div class="image-wrapper">
                                        <div class="position-2 cursor" (click)="deleteImage(i)"> &#10005;</div>
                                          <img [src]="renderImage(photoarr[i])" alt="Profile-Pic" width="150" height="150"
                                              style="object-fit: cover;">
                                      </div>
                                  </div>
                              </div>
                              <label  class="btn-bs-file btn btn-lg " *ngIf="photoarr.length < this.photoLimit">
                                  <div > <span class="position">+</span> </div>
                                  <div style="position: absolute; top:40%; left:40%;"></div>
                                  <input type="file" (change)="uploadImage($event)" accept="image/*"/>
                              </label>
                          </div>
                      </div>
                      <div class="button-container">
                        <button type="button" class="pg-btn pg-btn--ghost" (click)="backDashboard()">Cancel</button>
                        <button type="button" class="pg-btn pg-btn--primary" (click)="onSubmit()">Save</button>
                      </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
